import script from "./NotFind.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFind.vue?vue&type=script&setup=true&lang=js"

import "./NotFind.vue?vue&type=style&index=0&id=07499b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07499b04"]])

export default __exports__